<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商户配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div class="config-box">
        <div class="config-wrap">
          <div class="config-left">
            <vue-affix-box :offset-top="80" style="margin-top: 10px; margin-bottom: 10px">
              <menu-view
                @change="handleMenuChange"
                :value="menuValue"
                :menuList="menuList"
                :loading="loading"
              />
            </vue-affix-box>
          </div>
          <div class="config-right">
            <account-info v-if="menuValue == 'account-info'" />
            <store-info v-else-if="menuValue == 'store-info'" />
            <vet-doctor v-else-if="menuValue == 'vet-doctor'" />
            <store-supplier v-else-if="menuValue == 'store-supplier'" />
            <store-printer v-else-if="menuValue == 'store-printer'" />
            <store-camera v-else-if="menuValue == 'store-camera'" />
            <store-lock v-else-if="menuValue == 'store-lock'" />
            <store-distributor v-else-if="menuValue == 'store-distributor'" />
            <store-shelf v-else-if="menuValue == 'store-shelf'" />
            <order-channel v-else-if="menuValue == 'order-channel'" />
            <outbound-channel v-else-if="menuValue == 'outbound-channel'" />
            <setting-form v-else :settingKey="menuValue" />
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<style lang="less" scoped>
.config-box {
  padding: 10px 10px;

  .config-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .config-left {
      width: 150px;
      min-height: 200px;
      margin-right: 20px;
    }

    .config-right {
      width: calc(100% - 170px);
      min-height: 200px;
    }
  }
}
</style>

<script>
import menuView from "../../../../components/menuView.vue";
import settingForm from "./__setting_form.vue";
import vetDoctor from "./__vet_doctor.vue";
import orderChannel from "./__order_channel.vue";
import outboundChannel from "./__outbound_channel.vue";
import storeInfo from "./__store_info.vue";
import accountInfo from "./__account.vue";
import storeSupplier from "./__store_supplier.vue";
import storePrinter from "./__store_printer.vue";
import storeCamera from "./__store_camera.vue";
import storeLock from "./__store_lock.vue";
import storeDistributor from "./__store_distributor.vue";
import storeShelf from "./__store_shelf.vue";

export default {
  components: {
    menuView,
    settingForm,
    vetDoctor,
    storeInfo,
    accountInfo,
    orderChannel,
    outboundChannel,
    storeSupplier,
    storePrinter,
    storeCamera,
    storeLock,
    storeDistributor,
    storeShelf,
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    handleFetchResp(resp) {
      this.settingList = (resp.data || []).filter((item) => {
        return !item.hidden;
      });
    },
    fetchSettingList() {
      this.loading = true;
      this.errorMsg = null;
      return this.requestApi(
        "biz.customer.base.setting.list",
        {},
        {
          cache: 1,
          cacheCallback: (resp) => {
            this.handleFetchResp(resp);
          },
        }
      )
        .then((resp) => {
          this.handleFetchResp(resp);
        })
        .catch((err) => {
          this.errorMsg =
            (err && (err.msg || err.message)) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleMenuChange(guid) {
      this.menuValue = guid;
    },
  },
  computed: {
    menuList() {
      let menuList = [
        {
          label: "仓库/门店",
          value: "store-info",
        },
        {
          label: "账号管理",
          value: "account-info",
        },
        {
          label: "供货单位",
          value: "store-supplier",
        },
        {
          label: "云打印机",
          value: "store-printer",
        },
        {
          label: "云摄像头",
          value: "store-camera",
        },
        {
          label: "云智能锁",
          value: "store-lock",
        },
        {
          label: "门店货位",
          value: "store-shelf",
        },
        {
          label: "订单渠道",
          value: "order-channel",
        },
        {
          label: "出库渠道",
          value: "outbound-channel",
        },
        {
          label: "职业兽医",
          value: "vet-doctor",
        },
      ];
      //   if (this.settingList && this.settingList.length > 0) {
      //     menuList.push(
      //       ...this.settingList.map((item) => {
      //         return {
      //           value: item.key,
      //           label: item.desc,
      //         };
      //       })
      //     );
      //   }
      return menuList;
    },
  },
  mounted() {
    this.fetchSettingList();
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      settingList: [],
      menuValue: "store-info",
    };
  },
};
</script>
